export default __webpack_public_path__ + "static/media/energy.fec6c32b.svg";